import WorkLogForm from "../workLogForm";
//--------------------------------------------------------------------------------------------
export default function CCTVForm({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Form Name", type: "text", required: true, docNum: true}, 
        {title: "Completed Linear Footage (ft)", nowrap: true, type: "number", required: true},
        {title: "Completed Lateral Footage (ft)", nowrap: true, type: "number", required: true}, 
        {title: "Video Required", type: "radio", required: true},
        {title: "Video Captured", type: "radio", required: true},
        {title: "Mark and Locate Required", type: "radio", required: true},
        {title: "Total Sewer Footage Mark / Locate (ft)", nowrap: true, type: "number"},
        {title: "Total Storm Footage Mark / Locate (ft)", nowrap: true, type: "number"}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            noPDF
            items = {items}
            {...rest}
        />
    )    
}